<template>
    <div class="w-full">
        <h1 class="ml-4 text-green-600 text-lg text-left">Address {{ itemIndex + 1}}</h1>
        <form id="smmr-form" class="my-2 mx-4 border border-gray-300 bg-gray-100" @submit.prevent="update">
            <div class="flex flex-wrap p-8" @change="dirtyForm()" @keydown="dirtyForm">
                <text-input v-model="form.address_line1" class="" label="* Address Line 1" :error="form.errors?.address_line1" @update:modelValue="value = $event" />
                <text-input v-model="form.address_line2" class="" label="Address Line 2" :error="form.errors?.address_line2" @update:modelValue="value = $event" />
                <text-input v-model="form.address_line3" class="" label="Address Line 3" :error="form.errors?.address_line3" @update:modelValue="value = $event" />
                <text-input v-model="form.city_town" class="" label="* City / Town" :error="form.errors?.city_town" @update:modelValue="value = $event" />
                <text-input v-model="form.county_state" class="" label="* County / State" :error="form.errors?.county_state" @update:modelValue="value = $event" />
                <text-input v-model="form.post_zip_code" class="" label="* Postal / Zip Code" :error="form.errors?.post_zip_code" @update:modelValue="value = $event" />
                <select-input v-model="form.country_id" class="" label="* Country" :error="form.errors?.country_id" @update:modelValue="value = $event">
                    <option v-for="item in countriesOfDomicileList" :key="item.reference" :value="item.reference">{{ item.name }}</option>
                </select-input>
                <text-input v-model="form.phone_number" class="" label="* Phone Number" :error="form.errors?.phone_number" @update:modelValue="value = $event" />
                <text-input v-model="form.alt_number" class="" label="Alternative Number" :error="form.errors?.alt_number" @update:modelValue="value = $event" />
                <select-input v-model="form.type_id" class="" label="* Address type" :error="form.errors?.type_id" @update:modelValue="value = $event">
                    <option v-for="item in contactDetailTypesList" :key="item.reference" :value="item.reference">{{ item.name }}</option>
                </select-input>
            </div>
            <div class="items-center">
                <div v-if="successMessage" class="mx-8 success-message">{{ successMessage }}</div>

                <div v-if="Object.keys(validationErrors).length > 0">
                    <p class="server-error mx-8">There were some validation issues, please check the fields above</p>
                </div>
                <div class="flex flex-wrap justify-center">
                    <application-component-save-button :disabled="formDirty" class="relative flex btn-green -ml-0 w-3/4 sm:w-52 justify-center sm:inline-block text-center" type="submit">
                        Save this address
                        <div v-if="loading" class="lds-ring-container absolute top-2 left-2">
                            <div class="lds-ring"><div /><div /><div /><div /></div>
                        </div>
                    </application-component-save-button>
                    <button class="w-3/4 sm:w-52 mt-0 sm:mt-8 my-8 sm:ml-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" type="button" @click="removeAddress">
                        Remove this address
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    components: {
        ApplicationComponentSaveButton,
        TextInput,
        SelectInput,
    },
    props: {
        contactDetailTypesList: Object,
        countriesOfDomicileList: Object,
        applicationReference: String,
        itemIndex: Number,
        contactData: {
            type: Object,
            default: function () {
                return {
                    reference: null,
                    address_line1: null,
                    address_line2: null,
                    address_line3: null,
                    city_town: null,
                    post_zip_code: null,
                    county_state: null,
                    country_id: null,
                    phone_number: null,
                    alt_number: null,
                    type_id: null,
                    application_id: this.applicationReference,
                }
            },
        },
    },
    data() {
        return {
            form: ({
                reference: this.contactData.reference,
                address_line1: this.contactData.address_line1,
                address_line2: this.contactData.address_line2,
                address_line3: this.contactData.address_line3,
                city_town: this.contactData.city_town,
                post_zip_code: this.contactData.post_zip_code,
                county_state: this.contactData.county_state,
                country_id: this.contactData.country_id,
                phone_number: this.contactData.phone_number,
                alt_number: this.contactData.alt_number,
                type_id: this.contactData.type_id,
                application_id: this.applicationReference,
                errors: {
                },
            }),
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
        }
    },
    computed: {
        validationErrors: {
            get: function() {
                return this.form.errors
            },
            set: function(newValue) {
                for (const key in newValue)
                {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },

    },
    methods: {
        removeAddress() {
            if(confirm('Are you sure you want to remove this address?'))
            {
                if (this.form.reference !== null)
                {
                    this.$store.dispatch('deleteContactDetails', {
                        applicationReference: this.applicationReference,
                        contactReference: this.form.reference,
                    }).then((response) => {
                        this.loading = false
                        this.form.errors = {}
                        this.successMessage = response.data
                        this.$emit('delete', this.itemIndex)
                    })
                    .catch(error => {
                        this.loading = false
                        this.form.errors = Object.values(error)
                        this.successMessage = ''
                    })
                }
                else
                {
                    this.$emit('delete', this.itemIndex)
                }
            }

        },
        update() {
            this.loading = true

            let method = ''
            if (this.form.reference !== null)
            {
                method = 'updateContactDetails'

            }
            else
            {
                method = 'createContactDetails'
            }

            this.$store.dispatch(method, {
                contactData: this.form,
                applicationReference: this.applicationReference,
                contactReference: this.form.reference,
            }).then((response) => {
                this.loading = false
                this.form.errors = {}
                this.successMessage = response.data.message
                this.form.reference = response.data.reference
                window.location.search += '&section=contactDetailsShow'
            })
            .catch(error => {
                this.loading = false
                this.form.errors = error.response.data.errors
                this.validationErrors = error.response.data.errors
                this.successMessage = ''
            })

            this.formDirty = false
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
    },
}
</script>